import { fontStyles } from '@/styles/typography';

import { AlertCircleIcon } from '@/ui/Icons/AlertCircleIcon';

export const SlippageAlert = ({
  slippageType,
  percentage,
  setShowTradeSettings,
  showMessage,
}: {
  slippageType: string;
  percentage?: number;
  /** Only In Market Mode we provide a link to open the settings */
  setShowTradeSettings?: (show: boolean) => void;
  /** In the Review step we hide the message & ability to open settings  */
  showMessage: boolean;
}) => {
  const leftText = slippageType === 'high' ? 'High Slippage Settings' : 'Low Slippage Settings';
  const rightText = percentage && Number.isInteger(percentage) ? `${percentage}%` : undefined;
  const message =
    slippageType === 'high'
      ? 'Your trade is at risk of getting front-runned. Consider lowering your slippage in '
      : 'Your transaction might not go through. Consider setting a higher slippage in ';
  return (
    <div className="bg-token-red-300 mt-6 rounded-lg overflow-hidden">
      <div
        className={fontStyles({
          variant: 'LABEL_MD',
          class: [
            'flex',
            'items-center',
            'py-2.5',
            'px-3',
            'text-token-red-1300',
            'rounded-[88px]',
          ],
        })}
      >
        <AlertCircleIcon className="size-4 text-token-red-900 shrink-0" />
        <span className="text-token-red-1300 mx-3">{leftText}</span>
        <span className="flex-grow text-token-red-1300 text-right">{rightText}</span>
      </div>
      {showMessage && (
        <div
          className={fontStyles({
            variant: 'BODY_SM',
            class: ['text-token-red-1300', 'px-3', 'pb-4'],
          })}
        >
          {message}
          <button
            onClick={() => setShowTradeSettings?.(true)}
            className={fontStyles({
              variant: 'BODY_SM',
              class: ['text-token-red-1300', 'underline', 'focus:outline-none', 'cursor-pointer'],
            })}
          >
            Settings.
          </button>
        </div>
      )}{' '}
    </div>
  );
};
